<template>
  <div v-if="visible">
    <button
      type="button"
      class="p-link layout-topbar-icon pwa-install-btn"
      :disabled="installing"
      :aria-label="$t('pwa_install_app')"
      @click="onInstallClick"
    >
      <i
        class="pwa-install-btn__icon pi pi-fw pi-download"
        aria-hidden="true"
      />
      <span class="pwa-install-btn__label">{{ $t("pwa_install_app") }}</span>
    </button>

    <Dialog
      v-model:visible="iosDialogVisible"
      :header="$t('pwa_install_ios_title')"
      :modal="true"
      :draggable="false"
      :style="{ width: 'min(92vw, 420px)' }"
    >
      <p class="pwa-install-ios-msg">
        {{ $t("pwa_install_ios_message") }}
      </p>
      <template #footer>
        <Button
          :label="$t('close')"
          class="p-button-secondary p-button-outlined"
          @click="iosDialogVisible = false"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import {
  getPwaInstallState,
  isPwaInstallVisible,
  promptPwaInstall,
  subscribePwaInstall,
} from "../../utils/pwaInstall";

export default {
  data() {
    return {
      installState: getPwaInstallState(),
      installing: false,
      iosDialogVisible: false,
      unsubscribe: null,
    };
  },
  computed: {
    visible() {
      return isPwaInstallVisible(this.installState);
    },
  },
  mounted() {
    this.unsubscribe = subscribePwaInstall((state) => {
      this.installState = state;
    });
  },
  beforeUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  },
  methods: {
    async onInstallClick() {
      if (this.installState.canInstall) {
        this.installing = true;
        try {
          await promptPwaInstall();
        } finally {
          this.installing = false;
        }
        return;
      }

      if (this.installState.showIosHint) {
        this.iosDialogVisible = true;
      }
    },
  },
};
</script>

<style scoped>
.pwa-install-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  height: 45px;
  padding: 0 0.5rem;
  border: none;
  background: transparent;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
}

.pwa-install-btn__icon {
  font-size: 1.25rem;
}

.pwa-install-btn:disabled {
  opacity: 0.65;
  cursor: wait;
}

@media (max-width: 576px) {
  .pwa-install-btn__label {
    display: none;
  }

  .pwa-install-btn {
    width: 45px;
    padding: 0;
    justify-content: center;
  }

  .pwa-install-btn__icon {
    font-size: 1.5rem;
  }
}

.pwa-install-ios-msg {
  margin: 0;
  line-height: 1.5;
  color: #5c6b7a;
}
</style>
